module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-down-0.93a7070f.svg";